import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const Invite: React.FC = () => {
  const { bookingId } = useParams<{ bookingId: string }>();

  // Here you can handle the bookingId if needed before redirecting
  // For example, calling an API to accept the invite using the bookingId
  console.log(`Received invite for booking: ${bookingId}`);

  // Redirect to the single booking page
  return <Navigate to={`/booking/${bookingId}`} replace />;
};
